import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../hooks/useScrollReveal';

export default function CTASection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const { ref: refText, isVisible: visibleText, style: styleText } = useScrollReveal({ threshold: 0.1, distance: 28, duration: 800, delay: 180 });
  const { ref: refBtn, isVisible: visibleBtn, style: styleBtn } = useScrollReveal({ threshold: 0.1, distance: 24, duration: 700, delay: 350 });

  return (
    <section className="w-full bg-white py-16 md:py-24">
      <div className="px-6 lg:px-[7%] flex flex-col items-center text-center">
        <div ref={ref} className="w-[92%] max-w-6xl aspect-[21/9] rounded-3xl overflow-hidden" style={style}>
          <img
            src="/assets/anthony/cta-editorial-gown.jpg"
            alt="Vestido de alta costura con capa negra, colección Anthony Sánchez"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div ref={refText} className="mt-12 md:mt-14 max-w-3xl" style={styleText}>
          <h2 className="font-serif text-brand-black text-[clamp(1.8rem,4vw,2.5rem)] leading-[1.4] tracking-[-0.02em]">
            <span className="block font-normal">Vive la experiencia de la</span>
            <span className="block italic text-brand-gray-300">
              alta costura <span className="not-italic text-brand-black font-bold">artesanal</span>
            </span>
          </h2>
        </div>

        <div ref={refBtn} className="mt-10" style={styleBtn}>
          <Link
            to="/vestidos-novia"
            className="inline-flex items-center justify-center bg-brand-black text-white font-sans text-[15px] font-medium tracking-wide px-12 py-4 rounded-full hover:scale-105 hover:shadow-[0_12px_40px_rgba(0,0,0,0.25)] transition-all duration-400 whitespace-nowrap"
          >
            Vestidos de Novia a Medida
          </Link>
        </div>
      </div>
    </section>
  );
}